import Papa from "papaparse";

export class CSVExporter {
    public exportToCSV(data: unknown[]) {
        return Papa.unparse(data);
    }
}